<template>
  <Layout>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <div class="input-group check-length">
                    <input
                      id="input_displayname"
                      name="input_displayname"
                      type="text"
                      class="form-control"
                      placeholder="Log code"
                      v-model="filter.masterLogCode"
                      v-on:keyup="onMasterLogCodeChange()"
                    />
                    <!-- <span class="input-validate-length"> {{ model.display_name.length }}/30 </span> -->
                  </div>

                  <div v-if="isSearchMasterLogFail" class="validate-invalid">
                    <span>ไม่พบข้อมูล</span>
                  </div>
                  <div
                    v-else-if="
                      isSearchMasterLogSuccess && masterLogCodeJsonString
                    "
                  >
                    <span>
                      <a
                        href="#"
                        class="text-decoration-none text-success"
                        @click="
                          onClickModalMoreDetail(
                            masterLogCodeJsonString,
                            'xl',
                            filter.masterLogCode,
                            'json'
                          )
                        "
                      >
                        <i class="bx bx-show"></i>
                        {{
                          masterLogCodeJsonString.length > 80
                            ? masterLogCodeJsonString.substring(0, 80 - 3) +
                              "..."
                            : masterLogCodeJsonString
                        }}
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  class="btn btn-primary waves-effect"
                  :disabled="filter.masterLogCode === ''"
                  @click="
                    onTraceIdentifierIdChange(filter.masterLogCode, 'code')
                  "
                >
                  <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                  Search By Log code
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-row form-group">
                  <div class="input-group check-length">
                    <input
                      id="input_TraceIdentifierId"
                      name="input_TraceIdentifierId"
                      type="text"
                      class="form-control"
                      placeholder="Trace Identifier Id"
                      v-model="filter.traceIdentifierId"
                      v-on:keyup="
                        onTraceIdentifierIdChange(filter.traceIdentifierId)
                      "
                    />
                    <!-- <span class="input-validate-length"> {{ model.display_name.length }}/30 </span> -->
                  </div>

                  <div
                    v-if="isSearchTraceIdentifierIdFail"
                    class="validate-invalid"
                  >
                    <span>ไม่พบข้อมูล</span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <button
                  type="button"
                  class="btn btn-primary waves-effect"
                  :disabled="filter.traceIdentifierId === ''"
                  @click="onTraceIdentifierIdChange(filter.traceIdentifierId)"
                >
                  <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                  Search By TraceIdentifier
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="items && items.length > 0">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group row">
              <div class="col-md-6">
                <input
                  v-model="search"
                  placeholder="ค้นหา"
                  class="form-control form-default"
                  style="width: 370px"
                  robot="txt-search-table"
                />
              </div>
              <div class="col-md-6 text-right"></div>
            </div>
            <div class="form-group row"></div>
            <div class="form-group row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="grouptable"
                    :empty-text="'Not found any result'"
                    :show-empty="items.length == 0"
                    :bordered="true"
                    :filter="search"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ firstRowOnPage + data.index }}
                      </div>
                    </template>
                    <template v-slot:cell(timestamp)="data">
                      <div class="text-right">
                        {{ data.value | formatDate }}
                      </div>
                    </template>
                    <template v-slot:cell(fields)="row">
                      <span
                        class="d-inline-block text-truncate"
                        style="min-width: 150px"
                      >
                        <a
                          href="#"
                          class="text-decoration-none"
                          @click="
                            onClickModalMoreDetail(
                              JSON.stringify(row.value),
                              'xl',
                              row.item.log_index,
                              'json'
                            )
                          "
                        >
                          <i class="bx bx-show"></i>
                          {{ row.value }}
                        </a>
                      </span>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-more-detail
      v-if="modalMoreDetail.isShow"
      :content="modalMoreDetail.content"
      :size="modalMoreDetail.size"
      :contentType="modalMoreDetail.contentType"
      :title="modalMoreDetail.title"
      v-model="modalMoreDetail.isShow"
    ></modal-more-detail>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <!-- end row -->
  </Layout>
</template>

<script>
// import { FormatDate, FormatDateTime } from "@/helpers/utils/format-date.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";

import moment from "moment";
// import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import logService from "@/helpers/service/log-provider";
import ModalMoreDetail from "@/components/consumer-logs/modal-more-detail.vue";

export default {
  page: {
    title: "System Log",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Loading, ModalMoreDetail },
  data() {
    return {
      isLoading: true,
      fullPage: true,
      title: "System Log",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "System Log",
          active: true,
        },
      ],
      items: [],
      search: null,
      filter: {
        isError: false,
        masterLogCode: "",
        traceIdentifierId: "",
      },
      isSearchMasterLogFail: false,
      isSearchMasterLogSuccess: false,
      isSearchTraceIdentifierIdFail: false,
      isSearchTraceIdentifierIdSuccess: false,
      masterLogCodeJsonString: "",
      firstRowOnPage: 1,
      fields: [
        {
          key: "index",
          label: "index",
          thStyle: "width:80px",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "timestamp",
          label: "timestamp",
          thStyle: "width:80px",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "log_index",
          label: "log_index",
          thStyle: "width:120px",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "fields",
          label: "Fields",
          sortable: true,
        },
      ],
      logs: [],
      modalMoreDetail: {
        isShow: false,
        content: "",
        contentType: "text",
        title: "",
        size: "lg",
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  filters: {
    formatDate: function (value) {
      if (!value) return "";
      return moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss.SSS");
    },
  },
  watch: {
    // "filter.masterLogCode": function (val, oldVal) {
    //   // this.isLoading = true;
    // },
  },
  methods: {
    async onMasterLogCodeChange() {
      this.isSearchMasterLogSuccess = false;
      let result = await logService.readLogCodeInfo(this.filter.masterLogCode);
      this.isSearchMasterLogFail = true;
      if (result.status === 200) {
        this.masterLogCodeJsonString = JSON.stringify(result.data);
        this.isSearchMasterLogFail = false;
        this.isSearchMasterLogSuccess = true;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      }
    },
    async onTraceIdentifierIdChange(id, filterType) {
      // console.log("filterType :>> ", filterType);
      if (id === "") {
        return;
      }
      if (!filterType) {
        filterType = "traceidentifier";
      }
      this.isSearchTraceIdentifierIdSuccess = false;
      let result = await logService.readLogIdentifier(id, filterType);
      this.items = [];
      this.isSearchTraceIdentifierIdFail = true;
      if (result.status === 200) {
       // console.log("result.data :>> ", result.data);
        // result.data.forEach(function (data) {
        //   data["timestamp"] = data["@timestamp"];
        //   delete data["@timestamp"];
        // });
        this.items = result.data;
        this.isSearchTraceIdentifierIdFail = false;
        this.isSearchTraceIdentifierIdSuccess = true;
      } else if (
        (result.status && result.status === 404) ||
        (result.response.status && result.response.status === 404)
      ) {
        console.log("error", result.response.data.message);
      }
    },
    onClickModalMoreDetail(content, size, title, contentType) {
      this.modalMoreDetail = {
        isShow: true,
        content: content,
        contentType: contentType,
        title: title,
        size: size,
      };
    },
    onLoad() {
      this.logs = [];
      // axios
      //   .get(`${process.env.VUE_APP_BASE_API_WATCHDOG}/logs?page=0&limit=50&isError=${this.filter.isError}`)
      //   .then((response) => {
      //     this.logs = response.data;
      //     console.log('test', this.logs)
      //     this.chartTransactionsTime()
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     this.errored = true;
      //     this.isLoading = false
      //   })
      //   .finally(() => (this.isLoading = false));
      this.isLoading = false;
    },
    chartTransactionsTime() {
      let series = [];
      let categories = [];
      let durations = [0];
      let maxDurations = [0];
      for (let i = 0; i < this.logs.length; i++) {
        let timelines = this.logs[i].timelines;
        durations.push(this.logs[i].duration);
        maxDurations.push(this.logs[i].maxDuration);
        for (let n = 0; n < timelines.length; n++) {
          let timestamp = timelines[n]._source["@timestamp"];
          let time = moment(timestamp).format("YYYY-MM-DD HH:mm:ss.SSS");
          categories.push(time);
        }
      }
      if (durations.length) {
        series.push({ name: "Durations", data: this.sorted(durations) });
      }
      // if (maxDurations.length) {
      //   series.push({ name: 'Max durations', data: this.sorted(maxDurations) })
      // }
    //  console.log(categories);
    //  console.log(series);
      this.splineAreaChart.series = series;
      this.splineAreaChart.chartOptions.xaxis.categories =
        this.sorted(categories);
      this.columnDatalabelChart.series[0].data = durations;
    },
    sorted: function (items) {
      function compare(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }

      return items.sort(compare);
    },
  },
};
</script>
<style>
.card > .card-body > .custom-checkbox {
  display: inline-block;
  margin-left: 12px;
}
</style>
